import { render } from "./SVGShelfForShelfLeft.vue?vue&type=template&id=951e5d24"
import script from "./SVGShelfForShelfLeft.vue?vue&type=script&lang=js"
export * from "./SVGShelfForShelfLeft.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__